import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { flowMobileDatePicker } from './mobiledatepicker.theme';
import { FlowDateTimePickerTabs } from './DateTimePickerTabs';

export const flowMobileDateTimePicker: Components<Theme>['MuiMobileDateTimePicker'] = {
  ...(flowMobileDatePicker as Components<Theme>['MuiMobileDateTimePicker']),
  defaultProps: {
    ...(flowMobileDatePicker.defaultProps as Components<Theme>['MuiDateTimePicker']['defaultProps']),
    slots: {
      ...(flowMobileDatePicker.defaultProps?.slots as Components<Theme>['MuiDateTimePicker']['defaultProps']['slots']),
      tabs: FlowDateTimePickerTabs,
    },
    slotProps: {
      ...(flowMobileDatePicker.defaultProps
        ?.slotProps as Components<Theme>['MuiDateTimePicker']['defaultProps']['slotProps']),
    },
    views: ['day', 'month', 'year', 'hours', 'minutes'],
  },
};
